<h2 mat-dialog-title>
    {{ 'polls_task_details.dialog_title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10 poll-aggregated-results">
    @if(loading){
        <p class="text-secondary pb-3"><i class="fa-solid fa-circle-notch fa-spin"></i></p>
    } @else {
        <div>
            <mat-button-toggle-group [(ngModel)]="pollDisplayMode" (valueChange)="onPollDisplayModeChange($event)" hideSingleSelectionIndicator="true" aria-label="Result mode">
                <mat-button-toggle [value]="'preview'">{{ 'polls_task_details.preview' | translate}}</mat-button-toggle>
                <mat-button-toggle [value]="'results'" [disabled]="poll.occurrences.length === 1 && poll.occurrences[0].status !== 'FinishedQuestionStatus'">{{ 'polls_task_details.results' | translate}}</mat-button-toggle>
                <mat-button-toggle [value]="'trends'" [disabled]="poll.occurrences.length < 2 && poll.occurrences[1]?.status !== 'FinishedQuestionStatus'">{{ 'polls_task_details.trends' | translate}}</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    
        <div class="row pb-3">
            <div class="col-md-6 pt-3 d-flex flex-column justify-content-start align-items-center">
                @switch (pollDisplayMode) {
                    @case ('preview') {
                        <div>
                            <poll-preview [previewType]="questionType"
                                          [poll]="questionForPreview"></poll-preview>

                            <p class="pt-3 text-secondary">
                                <!-- Author visibility: -->
                                @if(poll.displayAuthor){
                                    <small>
                                        <i class="fa fa-mask"></i> {{'polls_task_details.poll_properties.author_anonymous' | translate}}
                                    </small>
                                } @else {
                                    <small>
                                        <span class="fa-stack ">
                                            <i class="fa fa-mask fa-stack-1x"></i>
                                            <i class="far fa-slash fa-stack-1x"></i>
                                        </span> {{'polls_task_details.poll_properties.author_not_anonymous' | translate}}
                                    </small>
                                }
                            </p>
                            <p class="text-secondary">
                                <!-- Allow comments: -->
                                @if(poll.allowComments){
                                    <small>
                                        <i class="far fa-comment"></i> {{'poll_creation.customize_allow_comments_preview' | translate}}.
                                    </small>
                                } @else {
                                    <small>
                                        <span class="fa-stack">
                                            <i class="far fa-comment fa-stack-1x"></i>
                                            <i class="far fa-slash fa-stack-1x"></i>
                                        </span> {{'poll_creation.customize_not_allow_comments_preview' | translate}}.
                                    </small>
                                } 
                            </p>
                                
                        </div>
                    }
                    @case ('results') {
                        @if(selectedOccurrence && pollResults?.aggregatedResults?.results?.values){
                            <div class="px-2">
                                <h3 class="text-center text-secondary fw-normal fst-italic fs-6 py-3">
                                    {{pollResults?.label}}
                                </h3>
                                @if(pollResults?.teams?.length > 1){
                                    <p class="text-center text-secondary fw-bold">{{ 'polls_settings.aggregate_results_dialog.subtitle' | translate}}</p>
                                }
                                @if(poll.occurrences.length > 1){
                                    <p class="text-center text-secondary fw-bold"><small>{{ selectedOccurrence.startDate | date }} - {{ selectedOccurrence.endDate | date }}</small> </p>
                                }
                                <poll-results-chart [results]="$safeNavigationMigration(pollResults?.aggregatedResults.results)"
                                                [pollType]="$safeNavigationMigration(pollResults?.aggregatedResults.pollType)"
                                                [pollId]="$safeNavigationMigration(pollResults?.aggregatedResults.pollType)"
                                                [context]="'dialog'"></poll-results-chart>

                                @if(pollResults.aggregatedResults.participation > 0){
                                    <poll-results-legend [availableChoices]="poll.availableChoices"
                                                          [type]="poll.itemType"></poll-results-legend>
                                }
                            </div>
                        }
                    }
                    @case ('trends') {
                        @if(pollTrends){
                            <div class="px-2">
                                <h3 class="text-center text-secondary fw-normal fst-italic fs-6 py-3">
                                    {{pollTrends?.label}}
                                </h3>
                                <div>
                                    @switch(poll.itemType){
                                        @case('closedQuestionResultItem'){
                                            <recurring-closed-poll-result-trends-chart [series]="allTeamsAverageSerie"
                                                                                    [dates]="dates"
                                                                                    [chartId]="'trends-'+$safeNavigationMigration(pollResults?.aggregatedResults.pollId)"></recurring-closed-poll-result-trends-chart>
                                        }
                                        @default{
                                            <recurring-poll-result-trends-line-chart [dates]="dates"
                                                                                    [series]="series"
                                                                                    [chartId]="'trends-'+$safeNavigationMigration(pollResults?.aggregatedResults.pollId)"></recurring-poll-result-trends-line-chart>
                                        }
                                    }
                                </div>
                                   
                                <poll-results-legend [availableChoices]="poll.availableChoices"
                                                        [type]="poll.itemType"
                                                        [series]="series"
                                                        [trendAllResults]="pollTrends.allResults"></poll-results-legend>
                                
                            </div>
                        }
                    }
                }
            </div>
            <div class="col-md-6">
                    <div class="mt-2 mb-3 p-3 border rounded question-list-item" data-cy="userQuestionItem">
                        <!-- top : common infos  -->
                        <div class="">
                            <div class="d-flex justify-content-between align-items-bottom">
                                <h4 class="mb-2">{{'polls_task_details.poll_properties' | translate}} </h4>
                                <div>
                                    @if(poll.status === 'ScheduledQuestionStatus'){
                                        <span class="badge fw-semibold text-dark bg-warning-subtle border border-warning-subtle"><i class="fa-solid fa-circle-small text-warning pe-1"></i>{{'polls_settings.status.scheduled' | translate}}</span>
                                    }
                                    @if(poll.status === 'FinishedQuestionStatus'){
                                        <span class="badge fw-semibold text-bg-light bg-light"><i class="fa-solid fa-circle-small pe-1"></i>{{'polls_settings.status.ended' | translate}}</span>
                                    }
                                    @if(poll.status === 'LiveQuestionStatus'){
                                        <span class="badge fw-semibold text-success bg-success-subtle border border-success-subtle rounded-2"><i class="fa-solid fa-circle-small pe-1"></i>{{'polls_settings.status.live' | translate}}</span>
                                    }
                                </div>
                            </div>
                            <ul>
                                <li>                                   
                                    <small class="fw-bold text-secondary pe-2">{{'polls_task_details.author' | translate}}</small> <small class="fw-bold">{{poll.author.fullname}}</small>
                                </li>
                                <li>
                                    <small class="fw-bold text-secondary">{{'polls_task_details.teams' | translate}}</small>  
                                    <team-chip-list [teams]="poll.teams"></team-chip-list>
                                </li>
                                <li class="pb-3">
                                    <small class="fw-bold text-secondary pe-2">{{ 'polls_task_details.recurrence' | translate}}</small>
                                    @if(poll.recurrence.frequency !== 'once'){
                                        <i [ngClass]="{'d-none': !poll.recurrence.enabled }"
                                        class="fa-regular fa-arrows-repeat fs-6 pe-1"></i>
                                        <i [ngClass]="{'d-none': poll.recurrence.enabled }"
                                            class="fa-regular fa-play-pause fs-6 pe-1"></i>
                                        <span class="fst-italic">
                                            @switch (poll.recurrence.frequency){
                                                @case ('weekly'){
                                                    {{'polls_settings.recurrence_preview.weekly' | translate: {'value': getFrequencyStartDay(poll.occurrences[0].startDate, 'weekly')} }}.
                                                }
                                                @case ('monthly'){
                                                    {{'polls_settings.recurrence_preview.monthly' | translate: {'value': getFrequencyStartDay(poll.occurrences[0].startDate, 'monthly')} }}.
                                                }
                                            }
                                            {{ 'poll_results.trends_desc1' | translate }} {{poll.occurrences.length}} {{ 'poll_results.trends_desc2' | translate }}.
                                        </span>
                                            <button class="btn btn-outline-primary border btn-sm py-0 float-end mt-2" type="button" 
                                                    [disabled]="poll.occurrences.length < 2 && poll.occurrences[1]?.status !== 'FinishedQuestionStatus'"
                                                    (click)="getTrendPollResults(poll)">
                                                <i class="far fa-chart-line pe-1"></i> {{ 'polls_settings.show_trends' | translate}}
                                            </button>  
                                        
                                    }@else {
                                        <small class="text-secondary fst-italic pe-2">
                                            {{ 'polls_task_details.make_reccurrent' | translate}}
                                        </small>
                                        <div class="pb-3">
                                            <!-- #docregion mat-menu-trigger-for -->
                                            <button matButton [matMenuTriggerFor]="menu"
                                            class="btn btn-outline-primary border btn-sm py-1 float-end mt-2">
                                                <i class="fa-regular fa-arrows-repeat pe-1"></i><i class="fa-regular fa-play-pause pe-1"></i>{{'polls_settings.recurrence.make_recurrent' | translate}}
                                            </button>
                                            <!-- #enddocregion mat-menu-trigger-for -->
                                            <mat-menu #menu="matMenu">
                                                <button mat-menu-item (click)="makePollRecurrent('weekly')">{{'polls_settings.recurrence.make_recurrent.weekly' | translate}}</button>
                                                <button mat-menu-item (click)="makePollRecurrent('monthly')">{{'polls_settings.recurrence.make_recurrent.monthly' | translate}}</button>
                                            </mat-menu>
                                        </div> 
                                        @if(frequencyOfRecurrence){
                                            <small>
                                                <make-poll-reccurrent-form [poll]="poll"
                                                                            [frequency]="frequencyOfRecurrence"
                                                                            [context]="'complex'"
                                                                            (onDurationValueChanged)="onDurationValueChanged($event)"></make-poll-reccurrent-form>
                                                <div class="d-flex justify-content-end">
                                                    <button class="btn btn-secondary py-1 me-2" (click)="cancelPollReccurrence()">cancel</button>
                                                    <button class="btn btn-primary py-1" (click)="savePollReccurrence()">save</button>
                                                </div>
                                            </small>
                                           
                                        }
                                    }
                                </li>
                            </ul>
                        </div>
                           
                        <!-- bottom : occurence details  -->
                       <div class="border-top mt-3 pt-3">
                           <h4 class="mb-2">{{'polls_task_details.occurrences' | translate}} ({{poll.occurrences.length}})</h4>
                         
                            <poll-task-details-occurrence-list [occurrences]="poll.occurrences"
                                                               [selectedOccurrence]="selectedOccurrence"
                                                               [pollFrequency]="poll.recurrence.frequency"
                                                               (onSelectOccurence)="setSelectedOccurrence($event)"></poll-task-details-occurrence-list>
                          
                           
                       </div>
                       
                       @if(context === 'backlog' && poll?.id){
                        <div class="border-top mt-3 pt-3">
                            <h4 class="mb-2">{{'poll_results.settings' | translate}} </h4>
                            @if(poll?.id){
                                <a class="text-secondary ms-2" [routerLink]="['/setup/polls']" [queryParams]="{poll: poll.id}" target="_blank">{{ 'polls_task_details.poll_setup' | translate }} <i class="fas fa-arrow-up-right-from-square"></i> </a>
                            }
                        </div>
                        }
                   </div>
                </div>
        </div>

        <!-- Details tabs -->
        @if(poll?.teams?.length > 1){
            @switch (pollDisplayMode) {
                @case ('preview') {}
                @case ('results') {
                        <div class="mx-3 details-divider">
                            <p class="fst-italic text-secondary pb-2">{{'polls_settings.aggregate_results_dialog.details'| translate}}</p>
                        </div>
                        <div class="tabs-wrapper">
                            <mat-tab-group>
                                <!-- Details by Team -->
                                                <mat-tab label="{{'polls_settings.aggregate_results_dialog.byteam' | translate}}"> 
                                                    <ng-template matTabContent>
                                                        <div class="row pt-3">
                                                            @if(poll?.teams?.length !== 0){
                                                                @for(team of pollResults?.teams; track team.teamId){
                                                                    <div class="col-md-4">
                                                                        <p class="fw-bold text-center text-secondary">
                                                                            {{team.teamName}}
                                                                            <a class="ps-1" href="{{team.timelineItemLink}}" target="_blank"
                                                                                matTooltip="{{ 'polls_settings.see_in_timeline'| translate}}">
                                                                                <i class="fa-solid fa-up-right-from-square"></i>
                                                                            </a>
                                                                        </p>
                                                                        @if(team.results?.values && team.participation > 0){
                                                                        <poll-results-chart [results]="team.results"
                                                                                            [pollType]="team.pollType"
                                                                                            [pollId]="team.teamId"></poll-results-chart>
                                                                        }@else {
                                                                            <p class="text-center text-secondary">{{ 'polls_settings.aggregate_results_dialog.byteam_no_participation' | translate}}</p>
                                                                        }
                                                                    </div>
                                                                }
                                                            }
                                                        </div>
                                                    </ng-template>
                                                </mat-tab>    
                                <!-- Details by Team with comments -->
                                                @if(hasComments($safeNavigationMigration(pollResults?.aggregatedResults?.results?.values)) && poll?.teams.length > 1){
                                                <mat-tab label="{{'polls_settings.aggregate_results_dialog.bycomments' | translate}}" 
                                                        [disabled]="!hasComments($safeNavigationMigration(pollResults?.aggregatedResults?.results?.values))">
                                                    <ng-template matTabContent>
                                                        <div class="charts-with-comments pt-3">
                                                            @if(poll?.teams.length !== 0){
                                                                @for(team of pollResults?.teams; track team.teamId){
                                                                    @if(team.results?.values){
                                                                        <div class="px-5 py-3 chart-with-comments">
                                                                            <p class="fw-bold text-center text-secondary pb-2">
                                                                                {{team.teamName}}
                                                                                <a class="ps-1" [attr.target]="'_blank'"
                                                                                [routerLink]="['/home', team.teamId, {fragment: team.pollId}]"
                                                                                [matTooltip]="'polls_settings.see_in_timeline' | translate "
                                                                                    matTooltipPosition="above">
                                                                                    <i class="fa-solid fa-up-right-from-square"></i>
                                                                                </a>
                                                                            </p>
                                                                            <div>
                                                                                <poll-results-chart [results]="team.results" 
                                                                                        [pollType]="team.pollType"
                                                                                        [pollId]="team.teamId+'-comments'"></poll-results-chart>
                                                                            </div>
                                                                            <div class="py-4">
                                                                                <poll-result-comments [commentResults]="team.results.values"
                                                                                                    [itemType]="convertPollTypeIntoTimelineItemType(team.pollType)"></poll-result-comments>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                }
                                                            }
                                                        </div>
                                                    </ng-template>
                                                </mat-tab>
                                                }
                                <!-- All comments -->
                                                <mat-tab [label]="hasComments(pollResults?.aggregatedResults.results.values)?translate.instant('polls_settings.aggregate_results_dialog.allcomments', {count: commentCount(pollResults?.aggregatedResults.results.values)}):translate.instant('polls_settings.aggregate_results_dialog.nocomments')" [disabled]="!hasComments(pollResults?.aggregatedResults.results.values)">
                                                    <div class="all-comments pt-3">
                                                        <div class="pb-4">
                                                            <poll-result-comments [commentResults]="pollResults?.aggregatedResults.results.values"
                                                                                [itemType]="convertPollTypeIntoTimelineItemType($safeNavigationMigration(pollResults?.aggregatedResults.pollType))"></poll-result-comments>
                                                        </div>
                                                    </div>
                                                </mat-tab>
                                    </mat-tab-group>   
                        </div> 
                
                    }
                @case('trends') {
                    <!-- Details by Team -->
                    <!-- @if((poll.itemType === 'closedQuestionResultItem') && pollTrends.allResults.values.length > 1){ -->
                    @if((poll.itemType === 'closedQuestionResultItem') ){
                        <div class="mx-3 details-divider">
                            <p class="fst-italic text-secondary pb-2">{{'polls_settings.aggregate_results_dialog.details'| translate}}</p>
                        </div>
                        <div class="tabs-wrapper">
                            <mat-tab-group>
                                    <mat-tab label="{{'polls_settings.aggregate_results_dialog.byteam' | translate}}"> 
                                        <ng-template matTabContent>
                                            <div class="row pt-3">
                                                    @for(teamOccurences of series; track $index){
                                                        <div class="col-md-4">
                                                            <p class="fw-bold text-center text-secondary">{{teamOccurences.name}}</p>
                                                            @if(teamOccurences?.data){
                                                                <recurring-closed-poll-result-trends-chart [series]="teamOccurences"
                                                                                                        [dates]="dates"
                                                                                                        [chartId]="'trends-'+data.pollId+'-' + $index"></recurring-closed-poll-result-trends-chart>
                                                            }
                                                        </div>
                                                    }
                                            </div>
                                        </ng-template>
                                    </mat-tab>    
                                    </mat-tab-group>   
                                </div> 
                        }
                }
            }
        }
    }
    
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'close' | translate}}</button>
</mat-dialog-actions>